import Vue from "vue";
import VChart from "vue-echarts";

// Import full echarts (includes all charts, components, and renderers)
import "echarts";

Vue.component("chart", VChart);
